import _ from 'lodash';
//constants
import { IcreateFormProps, fieldType, validationProps } from './types';
import { FormGroup, Stack } from '@mui/material';
import { SelectBox } from '../FormCreator/inputs/SelectBox';
import { SelectAutocomplete } from '../FormCreator/inputs/Autocomplete';
// import InputText from './inputs/InputText';
// import DatePicker from './inputs/DatePicker';
// import TextArea from './inputs/TextArea';
import { DateRangePickerInput } from '../FormCreator/inputs/DateRangePickerInput';
import React from 'react';
import Radio from './inputs/Radio';
import InputText from './inputs/InputText';

export const getErrorText = (fields: { [key: string]: validationProps } = {}, name: string) => {
	if (_.has(fields, name)) {
		return _.get(fields, name).errorText;
	}
	return '';
};

export const isValid = (fields: { [key: string]: validationProps } = {}, name: string) => {
	if (_.has(fields, name)) {
		return _.get(fields, name).valid;
	}
	return true;
};

export const FormCreator = (props: IcreateFormProps): JSX.Element => {
	// TOOD: change form creator to render children also so can render parts of form
	return (
		<>
			{props.fieldsGroups.map((fieldGroup, i) => {
				return (
					<FormGroup
						key={`fieldgroup-${i}`}
						id={String(i)}
						sx={{ marginTop: i > 0 ? '0!important' : 'initial' }}
					>
						<Stack
							sx={{
								display: 'flex',
								flexDirection: fieldGroup.type,
								...fieldGroup.styleObj,
							}}
							spacing={fieldGroup?.spacing || 2}
						>
							{fieldGroup.fields.map((cField, inx) => {
								const inputProps = {
									key: inx,
									cField: cField,
									handleChange: props.handleChange,
									initialValidation: props.initialValidation,
									valid: isValid(props.initialValidation, cField.props.name),
								};
								switch (cField.type) {
									case fieldType.text:
										return <InputText {...inputProps} />;
									case fieldType.select:
										return <SelectAutocomplete {...inputProps} />;
									case fieldType.selectBox:
										return <SelectBox {...inputProps} />;
									case fieldType.radio:
										return <Radio {...inputProps} />;
									// case fieldType.datePicker:
									// 	return <DatePicker {...inputProps} />;
									// case fieldType.textArea:
									// 	return <TextArea {...inputProps} />;
									case fieldType.dateRangePicker:
										return <DateRangePickerInput {...inputProps} />;
									default:
										return <></>;
								}
							})}
						</Stack>
					</FormGroup>
				);
			})}
		</>
	);
};
